import qs from 'qs'
import axios from 'axios'

// 广告主充值申请列表查询
export function rechargeList (params) {
  return axios.get('/iadadrrecharge/list', {
  	params
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch(err => {
    console.log(err)
  })
}

//广告主充值申请列表导出
export function IADAdrRechargeExport (params) {
  return axios.get('/iadadrrecharge/IADAdrRechargeExport', {
  	params
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch(err => {
    console.log(err)
  })
}

// 审核通过驳回接口
export function pass(params) {
  return axios.post('/IadAdrRecharge/audit', qs.stringify(params)).then((res) => {
    return Promise.resolve(res.data)
  }).catch(err => {
    console.log(err)
  })
}
//获取销售人接口
export function GetSalesman (params) {
  return axios.get('/IAD_Customer/GetSalesman', {
  	params
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch(err => {
    console.log(err)
  })
}
//获取广告运营接口
export function GetUserAdOperatorUser (params) {
  return axios.get('/IAD_Customer/GetUserAdOperatorUser', {
  	params
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch(err => {
    console.log(err)
  })
}

//获取修正记录接口
export function recordList(params) {
  return axios.post('/IadFinanceCorrect/List', qs.stringify(params)).then((res) => {
    return Promise.resolve(res.data)
  }).catch(err => {
    console.log(err)
  })
}

//获取退款申请表
export function refundList(params) {
  return axios.post('/IadFinanceReFun/List', qs.stringify(params)).then((res) => {
    return Promise.resolve(res.data)
  }).catch(err => {
    console.log(err)
  })
}

//充值金额返点金额修改接口
export function CheckMoney(params) {
  return axios.post('/IadFinanceCorrect/CheckMoney', qs.stringify(params)).then((res) => {
    return Promise.resolve(res.data)
  }).catch(err => {
    console.log(err)
  })
}

//退款拒绝通过驳回接口
export function refundPass(params) {
  return axios.post('/IadFinanceReFun/Audit', qs.stringify(params)).then((res) => {
    return Promise.resolve(res.data)
  }).catch(err => {
    console.log(err)
  })
}

//退款列表导出
export function refundExport (params) {
  return axios.get('/IadFinanceReFun/Export', {
  	params
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch(err => {
    console.log(err)
  })
}
//获取弹窗销售人员列表
export function GetDialogSalesman (params) {
  return axios.get('/iadadrrecharge/getallsalesman', {
  	params
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch(err => {
    console.log(err)
  })
}
//修改销售人员接口
export function UpdateSalesMan(params) {
  return axios.post('/iadadrrecharge/UpdateSalesMan', qs.stringify(params)).then((res) => {
    return Promise.resolve(res.data)
  }).catch(err => {
    console.log(err)
  })
}


// WEBPACK FOOTER //
// ./src/api/rechargeWithRefund.js